var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.191,
    height: 113.614,
    viewBox: "0 0 130.191 113.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transaction",
    transform: "translate(-1142.525 -645.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858",
    transform: "translate(-6780.475 16620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5195",
    "data-name": "Path 5195",
    d: "M8015.131-15958.242h8.57l.416,11.895-4.485.75-2.077-1.644Z",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5194",
    "data-name": "Path 5194",
    d: "M7996.34-15961.729l14.887-4.508s7.5,20.089,7.016,20.1-13.327.756-13.327.756Z",
    fill: "rgba(0,0,0,0.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9472",
    "data-name": "Rectangle 9472",
    width: 103,
    height: 77,
    rx: 4,
    transform: "translate(7923 -15937.5)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9473",
    "data-name": "Rectangle 9473",
    width: 103,
    height: 74,
    rx: 4,
    transform: "translate(7932 -15944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9474",
    "data-name": "Rectangle 9474",
    width: 26,
    height: 18,
    transform: "translate(8012 -15917)",
    fill: "#dc2039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image_38_Traced_",
    "data-name": "image 38 (Traced)",
    d: "M36.652,13.643,15.409,27.266l-5.078.007c-5.873.008-6.73.168-8.3,1.549A7.578,7.578,0,0,0,.514,30.749L0,31.792v69.342l.617,1.257a6.425,6.425,0,0,0,1.466,1.929c1.8,1.428-2.083,1.328,51.162,1.323,48.255,0,48.461-.007,49.447-.453a6.468,6.468,0,0,0,2.936-2.734c.469-.868.477-1.056.538-12.933l.062-12.052h1.544c1.345,0,1.613-.069,2.084-.54l.54-.54,0-9.751c0-7.406-.07-9.883-.281-10.3-.258-.511-.408-.555-2.088-.614l-1.81-.064V43.93c0-12.838-.005-12.893-1.3-14.469a7.457,7.457,0,0,0-1.81-1.413c-1.127-.619-1.323-.652-4.426-.732l-3.247-.084V21.141c0-5.156-.053-6.166-.343-6.58-.336-.48-.433-.489-5.126-.489H85.177l-1.2-3.662c-.9-2.748-1.328-3.744-1.7-3.99-.462-.3-1.052-.164-8.035,1.9-4.144,1.226-7.645,2.229-7.779,2.229a41.961,41.961,0,0,1-3.292-4.66C59.5.292,59.252-.023,58.481,0,58.1.013,50.414,4.817,36.652,13.643Zm29.481,1.446C70.513,21.7,74.058,27.15,74.011,27.2s-12.133.059-26.859.029l-26.775-.056,18.759-12.03C49.454,8.522,57.957,3.1,58.033,3.087S61.754,8.475,66.134,15.088Zm17.642,3c1.594,4.873,2.941,8.935,3,9.025a31.8,31.8,0,0,1-4.646.165H77.381L72.758,20.35c-2.543-3.811-4.648-7.046-4.68-7.189C68.027,12.925,79.524,9.3,80.5,9.25,80.806,9.232,81.436,10.933,83.776,18.089ZM92.787,22v5.283h-3.2l-1.7-5.123c-.936-2.818-1.7-5.2-1.7-5.283a17.27,17.27,0,0,1,3.3-.16h3.3Zm9.021,8.31a3.944,3.944,0,0,1,1.266,1.133l.5.748V55.677h-11.1c-9.8,0-11.142.041-11.447.346s-.346,1.568-.346,10.554V76.785l.489.343c.427.3,1.886.343,11.452.343h10.963l-.061,11.884-.061,11.884-.829.829-.829.829-48.481.055c-48.308.055-48.483.053-49.209-.39a3.456,3.456,0,0,1-1.151-1.376c-.411-.9-.423-1.873-.428-34.5,0-21.19.074-33.848.21-34.321a3.463,3.463,0,0,1,1.876-2.129c.544-.242,9.13-.295,48.54-.3C98.316,29.922,101.085,29.944,101.808,30.307Zm5.948,36.267v8.255H83.1V58.318h24.655Z",
    transform: "translate(7929.551 -15973.865)",
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_938",
    "data-name": "Ellipse 938",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(8018 -15911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M7946.906-15946.464l41.054-25.868,18.667,26.718h-59.721",
    fill: "rgba(0,0,0,0.2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "translate(-5632.642 14392.149) rotate(16)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "matrix(0.407, 0.914, -0.914, 0.407, -13678.855, 4224.916)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5168",
    "data-name": "Path 5168",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "translate(-10946.303 9988.586) rotate(42)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/no_transaction.c63b931ca41cbc45eb0bc18811386c0f.svg";
export { ForwardRef as ReactComponent };